import React, { forwardRef } from 'react';

import { FormControl, FormHelperText, FormLabel, Textarea, useTheme } from '@mui/joy';
import { SxProps } from '@mui/system';

interface Props {
  label: string;
  name: string;
  placeholder?: string;
  error?: string;
  value?: string;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  classNames?: string;
  required?: boolean;
  sx?: SxProps;
  minRows?: number;
  maxRows?: number;
}

export const TextAreaField = forwardRef<HTMLTextAreaElement, Props>(
  (
    {
      label,
      name,
      placeholder,
      error,
      value,
      disabled = false,
      required = false,
      onChange,
      classNames,
      sx,
      minRows,
      maxRows
    },
    ref
  ) => {
    const theme = useTheme();

    return (
      <FormControl className='mb-4' error={!!error} required={required}>
        <FormLabel style={{ color: disabled ? theme.palette.neutral[400] : '' }}>{label}</FormLabel>
        <Textarea
          className={classNames}
          disabled={disabled}
          id={name}
          maxRows={maxRows}
          minRows={minRows}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          slotProps={{ textarea: { ref } }}
          sx={sx}
          value={value}
        />
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    );
  }
);

TextAreaField.displayName = 'TextAreaField';
